
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsletters/[newsletterId]/edit",
      function () {
        return require("private-next-pages/newsletters/[newsletterId]/edit.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsletters/[newsletterId]/edit"])
      });
    }
  